
// 登录用户信息
export const SET_USERINFO = 'SET_USERINFO'

// 登录状态
export const SET_LOGIN = 'SET_LOGIN'

// 租户信息
export const SET_COMPANYINFO = 'SET_COMPANYINFO'

// token过期时间
export const SET_TOKENTIMEOUT = 'SET_TOKENTIMEOUT'

// 租户ID
export const SET_TENANTID = 'SET_TENANTID'

// 购物车数量
export const SET_CHATNUM = 'SET_CHATNUM'

// 分类搜索
export const SET_CLASSIFICATION = 'SET_CLASSIFICATION'
// 设置图片来源拼接地址
export const SET_OSSFILEURL = 'SET_OSSFILEURL'

// 表格列设置
export const SET_USERCOLUMNSSETTING = 'SET_USERCOLUMNSSETTING'
